/**
 * @generated SignedSource<<d752273960d62c97543fd5c98cc9b483>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef";
};
export type components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef$key = {
  readonly " $data"?: components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraComponentsField"
};

(node as any).hash = "616223369097ff7023289b730e24e390";

export default node;
